import { isValidUsername } from "@lorevok/domain";

/**
 * What goes after /u/ for an author: their username, or — for an owner with no
 * profile (the `system` demo owner, a no-auth `local_user`, whose byline is the
 * reserved "author" fallback) — their id. The API resolves either.
 */
export function authorRouteKey(ownerId: string, username?: string | null): string {
  return username && isValidUsername(username) ? username : ownerId;
}
